import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SmallLoader from '../pieces/SmallLoader';

function ImageLoader({...props}){
  let loader;
  if(props.imageStatus === 'loading'){
      loader = (<SmallLoader/>);
  }
  else if(props.imageStatus === 'loaded'){
    loader = ('');
  }
  else if(props.imageStatus === 'error'){
   
    //loader = (<div className="text-center">No image available</div>);
    loader = (<SmallLoader/>);

  }
  return(
    <div>
    { loader }
  </div>
  )
  
}


class PhotoModal extends Component {
  state = {
    imageStatus: 'loading'
  }
  
  handleImageLoaded = () => {
   this.setState({ imageStatus: 'loaded' }); 
   
   var contentEl = document.getElementsByClassName('modal-content')[0];
   var photoEl = document.getElementsByClassName('photo')[0];
   contentEl.style.width = (photoEl.naturalWidth + 16) + 'px';
   //contentEl.style.height = (photoEl.naturalHeight + 46) + 'px';
  }
  handleImageErrored = () => {
    this.setState({ imageStatus: 'error' });
  }
  prevPhoto = (e) => {
    this.setState({imageStatus: 'loading'});
    this.props.prevPhoto(e);
  }
  nextPhoto = (e) => {
    this.setState({imageStatus: 'loading'});
    this.props.nextPhoto(e);
  }
  render(){
    var imgClass = 'hidden';
    if(this.state.imageStatus === 'loaded'){
      imgClass = '';
    }

    return(
      <div className="modal-overlay dark show">

        <div className="modal-container modal-photo show" id="modal1">
            
            <div className="modal-content">
              <a className="modal close" onClick={this.props.handleClose} href="/"><i className="fa fa-times fa-lg" aria-hidden="true"></i></a>

                <ImageLoader
                  imageStatus={this.state.imageStatus}
                />

                <img 
                  className={`photo ${imgClass}`}
                  onLoad={this.handleImageLoaded}
                  onError={this.handleImageErrored}
                  src={`assets/img/photos/photo${this.props.photo.id}.jpg`}/>

                <div className="caption">{this.props.photo.caption}</div>
                <div className="photo-nav-wrapper">
                  { this.props.currNum > 1 &&
                    <Link className="photo-nav prev" onClick={this.prevPhoto} to="/"><i className="fa fa-chevron-left fa-2x" aria-hidden="true"></i></Link>
                  }
                  { this.props.currNum < this.props.photos.length && 
                    <Link className="photo-nav next" onClick={this.nextPhoto} to="/"><i className="fa fa-chevron-right fa-2x" aria-hidden="true"></i></Link>
                  }
                  
                </div>
                

            </div>
        </div>
      </div>
    );
  }
}
export default PhotoModal;


// WEBPACK FOOTER //
// ./src/modules/pieces/PhotoModal.js